<!--
 * @Author: xiaokun
 * @Date: 2020-03-02 14:22:06
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-03-23 14:13:01
 * @Description: 新建/编辑企业活码-第一步
 -->
<template>
  <div class="code-step-one">
    <mk-form
      ref="formDataOne"
      :model="formDataOne"
      :rules="rules"
      label-width="140px"
      class="form-data-one"
      label-position="right"
      prop="formDataOne"
    >
      <!-- 活码名称 -->
      <mk-form-item
        label="活码名称："
        prop="name"
      >
        <mk-input
          v-model="formDataOne.name"
          placeholder="请输入活码名称"
          maxlength="15"
          show-word-limit
        ></mk-input>
      </mk-form-item>
      <!-- 活码备注 -->
      <mk-form-item
        class="code-remark"
        label="活码备注："
        prop="remark"
      >
        <mk-input
          v-model="formDataOne.remark"
          placeholder="请输入活码备注"
          maxlength="15"
          show-word-limit
        ></mk-input>
      </mk-form-item>
      <!-- 分配规则 -->
      <mk-form-item
        label="二维码分配规则："
        prop="rule"
      >
        <mk-radio-group
          v-model="formDataOne.rule"
          @change="checkoutRule"
        >
          <mk-radio :label="1">
            随机分配
          </mk-radio>
          <mk-radio :label="2">
            <span class="tips-l1">依次分配，即扫满规定上限数即切换下一个</span>
            <br />
            <span class="tip2-l2">
              扫描达
              <mk-input-number
                v-model="limit"
                controls-position="right"
                :min="1"
                :max="4999"
                size="small"
                @blur="resetLimit"
              ></mk-input-number>个客户时，切换销售
            </span>
          </mk-radio>
        </mk-radio-group>
      </mk-form-item>
      <!-- 添加销售二维码 -->
      <mk-form-item
        label="添加销售二维码："
        prop="saleIDs"
      >
        <dept-member-select
          ref="deptmember"
          v-model="salesList"
          :can-select-dept="false"
          @optionVisibleChange="optionVisibleChange"
        />
      </mk-form-item>
      <!-- 已失效销售二维码 -->
      <mk-form-item
        v-if="isEdit && disableSale.length"
        label="已失效销售二维码："
        prop="disableSaleCode"
      >
        <div class="disable-sale-box">
          <span
            v-for="(item,index) in disableSale"
            :key="index"
          >{{ item }}</span>
        </div>
      </mk-form-item>
    </mk-form>
  </div>
</template>
<script>
import deptMemberSelect from '@components/dept-member-select'
import { ACCOUNTAPIS } from '@api'
export default {
  name: 'CodeStepOne',
  components: { deptMemberSelect },
  props: {
    // 是否是编辑 true:是 fasle:否
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    var checkSaleIDs = (rule, value, callback) => {
      if (this.formDataOne.saleIDs.length === 0 && !this.isCheckoutSaleId) {
        return callback(new Error('请选择销售二维码'))
      } else {
        return callback()
      }
    }
    return {
      isCheckoutSaleId: false,
      formDataOne: {
        name: '',
        remark: '',
        // 1:随机分配 2:依次分配
        rule: 2,
        saleIDs: []
      },
      salesList: {
        // 部门列表
        dept: [
          // {
          //   id: 'xxx',
          //   name: 'xxx'
          // }
        ],
        // 成员列表
        member: [
          // {
          //   id: 'xxx',
          //   name: 'xxx'
          // }
        ]
      },
      // 销售数量
      limit: 0,
      // 已失效销售列表
      disableSale: [],
      rules: {
        name: [
          { required: true, message: '请输入活码名称', trigger: 'blur' },
          { min: 1, max: 15, message: '长度在 1 到 15 个字符', trigger: 'blur' }
        ],
        rule: [
          { required: true, message: '请选择分配规则', trigger: 'change' }
        ],
        saleIDs: [
          {
            validator: checkSaleIDs,
            // type: 'array',
            // required: true,
            // message: '请选择销售二维码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    salesList () {
      this.submitForm()
    }
  },
  created () {
    this.getDeptList()
    this.getMembList()
  },
  mounted () {},
  methods: {
    async getDeptList () {
      // 获取部门信息
      const res = await ACCOUNTAPIS.OrganisationApi.v1OrganisationFindDepListGet(
        {}
      )
      if (res.success) {
        localStorage.setItem('departMemberDeptList', JSON.stringify(res.data))
      }
    },
    async getMembList () {
      // 获取成员列表
      const res = await ACCOUNTAPIS.OrganisationApi.v1OrganisationFindPlatformuserListGet(
        {}
      )
      if (res.success) {
        localStorage.setItem('departMemberList', JSON.stringify(res.data))
      }
    },
    // 编辑时 父级数据回显
    setData (data) {
      this.formDataOne = data
      // 销售回显处理逻辑
      data.userInfo.forEach(item => {
        // 当有停用销售 或者 离职销售时，将其展示在 已失效销售列表
        if (!item.enable_wx_qr_code || item.status === 'stop') {
          this.disableSale.push(item.name)
        }
        // 选择框内回显以及选择器内回显
        if (item.enable_wx_qr_code) {
          this.salesList.member.push({ id: item._id, name: item.name })
          // 调用组件内确认方法回显
          this.$refs.deptmember.confirmSelect(this.salesList)
        }
      })
      // 多少客户 回显
      this.limit = this.formDataOne.limit
    },
    // 父级调用，获取组件内的数据
    getData () {
      let saleIDs = []
      this.salesList.member.forEach(item => {
        // 编辑时，需要将每项销售  增加 numberOpenID: 0 传给后台，新建时不需要
        if (this.isEdit) {
          saleIDs.push({ saleID: item.id, numberOpenID: 0 })
        } else {
          saleIDs.push(item.id)
        }
      })
      this.formDataOne.saleIDs = saleIDs
      // 依次分配时，需要传 达多少个 客户时，切换销售二维码，随机时不需要
      if (this.formDataOne.rule === 2) {
        this.formDataOne.limit = this.limit
      }
      return this.formDataOne
    },
    // 校验表单方法
    async submitForm () {
      // 校验表单
      await this.getData()
      let result = ''
      this.$refs.formDataOne.validate(valid => {
        result = valid
      })
      return result
    },
    // 重置表单数据
    resetForm (formDataOne) {
      this.$refs.formDataOne.resetFields()
    },
    // 分配规则，当前规则为【随机分配】，输入扫描达 x 客户时，失焦时应讲当前所选规则变为【依次分配】
    resetLimit () {
      this.formDataOne.rule = 2
    },
    // 分配规则，由【依次分配】切换至【随机分配】时，重置 输入扫描达 x 客户时 的 x 为 1
    checkoutRule (val) {
      if (val === 1) {
        this.limit = 1
      }
    },
    // 判断选择时是否 展示
    optionVisibleChange (val) {
      this.isCheckoutSaleId = val
    }
  }
}
</script>

<style scoped lang="scss">
.code-step-one {
  max-width: 550px;

  /deep/.el-icon-circle-check {
    display: none !important;
  }

  .allot-rules-text {
    font-size: 13px;
  }

  /deep/ .el-tag__close {
    display: none !important;
  }

  // /deep/ .code-remark {
  //   margin-bottom: 14px !important;
  // }

  /deep/ .el-form-item__content {
    // 分配规则选择样式
    .el-radio__input.is-checked + .el-radio__label {
      color: #262626;
    }
    // 销售二维码
    .mk-select {
      width: 100% !important;
    }

    .el-radio-group {
      display: flex;
      align-items: flex-start;
      margin-top: 12px;

      .tips-l1 {
        margin-bottom: 16px;
        display: inline-block;
      }

      .tip2-l2 {
        display: inline-block;
        margin-left: 42px;

        .mk-input-number {
          max-width: 100px;
          margin: 0 5px;
        }
      }

      .el-radio__label {
        color: #262626;
        font-size: 13px;
      }
    }
  }

  // 已失效销售二维码
  .disable-sale-box {
    padding: 8px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    background-color: #f7f7f7;
    text-align: left;
    line-height: 1;
    margin-top: 5px;

    span {
      background-color: #ffeded;
      color: #e62412;
      margin-right: 5px;
      padding: 3px 6px;
      border-radius: 2px;
    }
  }
}
</style>
